import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

export const useFetchBroadcastMessages = ({
  page,
  itemsPerPage,
  showAll,
  statusFilters,
  sortBy,
  sortDirection,
}) => {
  const params = {
    page,
    limit: itemsPerPage,
    show_all: showAll,
    sort_by: sortBy,
    sort_direction: sortDirection,
  };

  // Add status filters if provided for server-side filtering
  if (statusFilters && statusFilters.length > 0) {
    params.by_statuses = statusFilters;
  }

  const {
    data = {
      broadcastMessages: [],
      pagy: {},
      canSendBroadcast: false,
      tier: undefined,
      nextFreeBroadcastDate: undefined,
    },
    isFetching,
    isLoading,
  } = useQuery(
    ['broadcastMessages', params],
    () => get('/api/client_admin/broadcast_messages', params),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );

  const {
    broadcastMessages,
    pagy,
    canSendBroadcast,
    tier,
    nextFreeBroadcastDate,
  } = data;

  return {
    broadcastMessages,
    pagy,
    isFetching,
    isLoading,
    canSendBroadcast,
    tier,
    nextFreeBroadcastDate,
  };
};

// Keyed by uuid so opening another broadcast never renders (or fetches
// recipients for) the previous one's cached data.
export const broadcastMessageKey = id => ['broadcastMessage', id];

export const useFetchBroadcastMessage = ({ id }) => {
  const {
    data: { broadcastMessage },
    isFetching,
  } = useQuery(
    broadcastMessageKey(id),
    () => get(`/api/client_admin/broadcast_messages/${id}`),
    {
      refetchOnWindowFocus: false,
      enabled: !!id,
      initialData: {
        broadcastMessage: {},
      },
    },
  );

  return {
    broadcastMessage,
    isFetching,
  };
};
